import {
    CFDClientMessageType,
    ISendToPOSMessage,
} from 'pages/CustomerFacingDisplayPage/reducer/Interface'
import { useReducer } from 'react'
import { useApplyLoggerDispatch } from 'utilities/debug/logUtil'

interface IState {
    isHWAgetOnline: boolean
    version: string
    compatibilityVersion: string
    latestVersion: string
    isOlderLatestVersion: boolean
    isUncompatibleVersion: boolean
    isConnected: boolean
    latestMessageToCFD: ISendToPOSMessage
}
const initialState: IState = {
    isHWAgetOnline: false,
    version: '',
    compatibilityVersion: '',
    latestVersion: '',
    isOlderLatestVersion: false,
    isUncompatibleVersion: false,
    isConnected: false,
    latestMessageToCFD: {
        type: CFDClientMessageType.Order,
        payload: { orderItems: [], orderDiscounts: [] },
    },
}

type ICFDHWAgentActionType =
    | {
          type: 'READY_CONNECT_TO_CFD'
      }
    | {
          type: 'NO_READY_CONNECT_TO_CFD'
      }
    | {
          type: 'HW_AGENT_ONLINE'
      }
    | {
          type: 'HW_AGENT_OFFLINE'
      }
    | {
          type: 'SET_HW_AGENT_VERSION'
          payload: {
              version: string
              compatibilityVersion: string
              latestVersion: string
          }
      }
    | {
          type: 'SET_HW_AGENT_VERSION_STATUS'
          payload: {
              isUnderLatestVersion: boolean
              isUncompatibleVersion: boolean
          }
      }
    | {
          type: 'SET_LATEST_MESSAGE'
          payload: ISendToPOSMessage
      }

function CFDHwAgentReducer(
    state: IState = initialState,
    action: ICFDHWAgentActionType,
): IState {
    switch (action.type) {
        case 'READY_CONNECT_TO_CFD':
            return {
                ...state,
                isConnected: true,
            }
        case 'NO_READY_CONNECT_TO_CFD':
            return {
                ...state,
                isConnected: false,
            }
        case 'HW_AGENT_ONLINE':
            return {
                ...state,
                isHWAgetOnline: true,
            }
        case 'HW_AGENT_OFFLINE':
            return {
                ...state,
                isHWAgetOnline: false,
            }
        case 'SET_HW_AGENT_VERSION':
            return {
                ...state,
                version: action.payload.version,
                compatibilityVersion: action.payload.compatibilityVersion,
                latestVersion: action.payload.latestVersion,
            }
        case 'SET_HW_AGENT_VERSION_STATUS':
            return {
                ...state,
                isOlderLatestVersion: action.payload.isUnderLatestVersion,
                isUncompatibleVersion: action.payload.isUncompatibleVersion,
            }
        case 'SET_LATEST_MESSAGE':
            return {
                ...state,
                latestMessageToCFD: action.payload,
            }
        default:
            return state
    }
}

const useCFDHubReducer = () => {
    const [hwAgentObject, dispatch] = useReducer(
        CFDHwAgentReducer,
        initialState,
    )

    const dispatchFunc = useApplyLoggerDispatch(
        'CFDHardwareAgentAction',
        dispatch,
        hwAgentObject,
    )

    return { state: hwAgentObject, dispatch: dispatchFunc }
}
export default useCFDHubReducer
